import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "How much does a WordPress developer charge?",
    answer: `<p>The average hourly rate for a WordPress developer is around $33 per hour, serving as the midpoint between the lower and upper ranges. However, this figure can fluctuate between $20 and $57, or more depending on factors such as experience, project complexity, and additional specialized skills.</p>`,
  },
  {
    question: "How much does it cost to build a WordPress website?",
    answer: `<p>The cost to build a WordPress website varies based on factors like design complexity, functionality requirements, and the scale of the project. Here are the cost details for building a WordPress website according to different types: <ul><li><strong>Blogging or Personal Website:</strong> $480 – $3600</li> <li><strong>E-commerce Website:</strong> $1200 – $6000</li> <li><strong>Business Website:</strong> $720 – $4200</li></ul></p>`,
  },
  {
    question: "Does WordPress design websites?",
    answer: `<p>Absolutely! WordPress is a content management system (CMS) that allows you to host and build websites. Moreover, WordPress contains plugin architecture and a template system that allows customization for various purposes like business, blogging, portfolios, or online stores.</p>`,
  },
  {
    question: "What is better Wix or WordPress?",
    answer: `<p>WordPress is the better option for those looking for advanced customization options while Wix is suitable for those desiring a user-friendly platform without technical expertise.</p>`,
  },
  {
    question: "How much time is needed to build a WordPress website?",
    answer: `<p>A single-page WordPress website can be built within two to eight days. However, incorporating features such as subscriptions and downloadable content will extend the overall timeline.</p>`,
  },
  {
    question:
      "What is the difference between WordPress design and WordPress development?",
    answer: `<p>A WordPress developer improves on the designer's work by adding new features and functionality to the website, focusing on technical refinement. On the other hand, a developer is a coding expert responsible for executing programming tasks.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>WordPress Development Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
